import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'

import styles from './styles.module.scss'
import Carousel from 'srcReact/components/common2/Carousel'
import MixrSuggestions from './components/MixrSuggestions'
import PendingMembers from './components/PendingMembers'
import { groupHomeActions } from 'srcReact/GroupHomePage'

const PendingActions = ({ groupId, isMobile }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    groupHome: { group, pending_members, suggested_mixrs, refreshPendingActions },
  } = useSelector((state) => state)
  useEffect(() => {
    if (group.logged_user.group_role === 'organizer' || group.logged_user.group_role === 'co-organizer') {
      dispatch(groupHomeActions.getGroupPendingActions(groupId))
    }
  }, [group, refreshPendingActions])

  return (
    <React.Fragment>
      {((suggested_mixrs.mixrs && suggested_mixrs.mixrs.length >= 1) ||
        (pending_members.users && pending_members.users.length >= 1)) && (
        <div className={styles.pendingActionsWrapper}>
          {suggested_mixrs.mixrs && suggested_mixrs.mixrs.length >= 1 && (
            <div className={styles.suggestedWrapper}>
              <div className={styles.heading}>
                {t('groupHome.header.mixrSuggestions')} ({suggested_mixrs.stats.total})
              </div>
              <div className={styles.content}>
                <Carousel
                  className={styles.carousel}
                  prevArrowClass={styles.prevArrowClass}
                  nextArrowClass={styles.nextArrowClass}
                  itemPadding={[0, 0]}
                  breakPoints={[{ itemsToShow: 1 }, { itemsToScroll: 1 }]}>
                  {suggested_mixrs.mixrs.map((m, i) => (
                    <MixrSuggestions mixr={m} key={i} isMobile={isMobile} index={i} />
                  ))}
                </Carousel>
              </div>
            </div>
          )}
          {pending_members.users && pending_members.users.length >= 1 && (
            <div className={styles.membersWrapper}>
              <div className={styles.heading}>
                {t('groupHome.header.pendingMembers')} ({pending_members.stats.total})
              </div>
              <div className={styles.content}>
                <Carousel
                  className={styles.carousel}
                  prevArrowClass={styles.prevArrowClass}
                  nextArrowClass={styles.nextArrowClass}
                  itemPadding={[0, 0]}
                  breakPoints={[{ itemsToShow: 1 }, { itemsToScroll: 1 }]}>
                  {pending_members.users.map((u, i) => (
                    <PendingMembers
                      key={i}
                      index={i}
                      groupId={groupId}
                      user={u}
                      members={pending_members.users}
                      isMobile={isMobile}
                    />
                  ))}
                </Carousel>
              </div>
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  )
}

export default PendingActions
